import { Component, OnInit } from '@angular/core';
import { LectionaryItemNameService } from '../../services/lectionary-item-name.service';

@Component({
  selector: 'app-lectionary-item-name-validate',
  templateUrl: './lectionary-item-name-validate.component.html',
  styleUrls: ['./lectionary-item-name-validate.component.css']
})
export class LectionaryItemNameValidateComponent implements OnInit {

  public passage = "";
  public result = "";

  constructor(
    private lectionaryItemNameSvc: LectionaryItemNameService) { }

  ngOnInit() {
  }

  public validate() {
    console.log("Validate", this.passage);

    this.lectionaryItemNameSvc.validate(this.passage)
    .then((s) => {
      this.result = s;
    })
    .catch((err) => {
      alert("There was an error while validating the name");
      console.log(err);
    });
  }

}
